export function checkBlackList(id: number, black_list: number[]): boolean {
    return black_list.includes(id)
}